import Modal from '../../common/Modal';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import Paper from '@material-ui/core/Paper';
import TableHeader from '../../common/Table/TableHeader';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { PropsCell } from '../../common/Table/TableHeader';
import { Button, Checkbox } from '@material-ui/core';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import React, { useCallback, useState } from 'react';
import { acceptLoanP2P, cancelLoanP2P } from '../../../redux/loans_p2p/thunks';
import { LoanStatus } from '../../../domain/constants/LoanStatus';
import { StatusP2PTransfer } from '../../../domain/constants/StatusP2PTransfer';
import { StatusP2KeyPOption } from '../../../domain/constants/StatusP2PTransferKeys';

type Props = {
  onClose: Function;
  aceptOrReject: (transaction_id: number, newStatus: LoanStatus) => void;
  loans_p2p_key_list: {
    loans_p2p_key: {
      id: number;
      properties_nid: string;
      barcode: string;
    }[];
  };
  p2p_transfer_status_id: StatusP2PTransfer;
  title?: string;
  target_user_id?: number | null;
  transfer_id: number | null;
};

export const LoanP2PShowModal = ({
  onClose,
  aceptOrReject,
  loans_p2p_key_list,
  title,
  transfer_id,
  target_user_id,
  p2p_transfer_status_id,
}: Props) => {
  const auth = useAppSelector((state) => state.auth);
  const allowAccept =
    StatusP2PTransfer.Pending === p2p_transfer_status_id &&
    `${auth.id}` === `${target_user_id}`;

  const headCells: PropsCell[] = [
    { id: 'id', numeric: false, disablePadding: false, label: 'ID' },
    {
      id: 'properties_nid',
      numeric: false,
      disablePadding: false,
      label: 'NID',
    },
    {
      id: 'barcode',
      numeric: false,
      disablePadding: false,
      label: 'Código de barras',
    },
    {
      id: 'checkbox',
      numeric: false,
      disablePadding: false,
      label: allowAccept ? 'Confirmar' : 'Status',
    },
  ];
  const dispatch = useAppDispatch();
  const [send, setSend] = useState(false);
  const [checkBoxList, setcheckBoxList] = useState<number[]>([]);
  const fetchAccept = useCallback(() => {
    dispatch<any>(
      acceptLoanP2P({ keys: checkBoxList, transfer_id: transfer_id! })
    )
      .unwrap()
      .then(() => aceptOrReject(transfer_id!, LoanStatus.Accept))
      .catch(() => setSend(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transfer_id, checkBoxList]);
  const fetchCancel = useCallback(() => {
    dispatch<any>(cancelLoanP2P({ transfer_id: transfer_id! }))
      .unwrap()
      .then(() => aceptOrReject(transfer_id!, LoanStatus.Cancel))
      .catch(() => setSend(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transfer_id]);
  const handleChangeIds = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selected = Number(event.target.name);
    if (checkBoxList.includes(selected)) {
      setcheckBoxList(checkBoxList.filter((id) => id !== selected));
    } else {
      setcheckBoxList([...checkBoxList, selected]);
    }
  };

  return (
    <Modal open={true} onClose={onClose} title={title || 'Transferencia P2P'}>
      <div>
        <TableContainer component={Paper}>
          <Table aria-label='simple table'>
            <TableHeader cellsList={headCells} />
            <TableBody>
              {loans_p2p_key_list.loans_p2p_key.map(
                (loans_p2p_key: any, key: any) => (
                  <TableRow>
                    <TableCell component='th' scope='row'>
                      {loans_p2p_key.id}
                    </TableCell>
                    <TableCell>{loans_p2p_key.properties_nid}</TableCell>
                    <TableCell>{loans_p2p_key.barcode}</TableCell>
                    <TableCell>
                      {allowAccept && (
                        <Checkbox
                          checked={checkBoxList.includes(loans_p2p_key.id)}
                          onChange={handleChangeIds}
                          name={loans_p2p_key.id}
                          color='primary'
                        />
                      )}
                      {!allowAccept &&
                        (StatusP2KeyPOption as any)[
                          loans_p2p_key?.p2p_transfer_key_status_id
                        ]}
                    </TableCell>
                  </TableRow>
                )
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <form>
        {allowAccept && (
          <Button
            size='medium'
            color='primary'
            variant='contained'
            disabled={send || !Boolean(checkBoxList.length)}
            onClick={() => fetchAccept()}
          >
            Aceptar
          </Button>
        )}
        {StatusP2PTransfer.Pending === p2p_transfer_status_id && (
          <Button
            size='medium'
            color='secondary'
            variant='contained'
            disabled={send}
            onClick={() => fetchCancel()}
          >
            Rechazar Todo
          </Button>
        )}
      </form>
    </Modal>
  );
};
